import { defineComponent as _defineComponent } from 'vue'
import {} from 'vue';
// types
import type { ReactionType } from '@/ts/public/type/ReactionType';

export default /*@__PURE__*/_defineComponent({
  __name: 'VueReactionButton',
  props: {
    type: { type: String, required: true },
    icon: { type: String, required: true },
    label: { type: String, required: true },
    count: { type: Number, required: true },
    active: { type: Boolean, required: true },
    disabled: { type: Boolean, required: true }
  },
  emits: ["clickReaction"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;


const emit = __emit



const __returned__ = { props, emit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})